import createReducer from "utils/createReducer";
import { UserTypes, ServerSentEventTypes } from "actions/types";

import { fromJS } from "immutable";

export const defaultValue = fromJS({
  displayName: null,
  showLanguage: false,
  balance: null,
  currency: null,
  symbol: null,
  externalLinks: [],
  links: [],
});

export const profile = createReducer(defaultValue, {
  [UserTypes.SET_BALANCE](state, { payload }) {
    let newState = state.merge(payload.get("data"));
    return newState;
  },
  [UserTypes.SET_PROFILE](state, { payload }) {
    let newState = state.merge(payload.get("data"));
    return newState;
  },
  [ServerSentEventTypes.MESSAGE_SERVER_SENT_EVENT](state, { payload }) {
    let newState = state;
    switch (payload.type) {
      case "player-balance-update":
        newState = newState.setIn(["balance"], payload.message.balance);
        return newState;
      default:
        return newState;
    }
  },
});
